<template>
  <div id="IndexArchivoJudicial_div">

    <menusuperior titulo="ARCHIVO" subtitulo="Gestión Documental del Archivo Judicial"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_ARCHIVO" class="d-flex justify-content-center align-items-center content-area">
      <div id="secciondebienvenidaARCHIVO" class="d-flex flex-wrap align-items-center justify-content-center">
        <figure class="text-center">
          <img src="../../../assets/paginaoficial/Logotipo_Positivo_Horizontal.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h2 class="h2-custom">BIENVENIDOS AL SISTEMA SIGDAJ</h2>
        <h4></h4>
      </div>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_ARCHIVO" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
 
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  //import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    },
    data() {
      return {
        RUTA_RAIZ_ARCHIVO: '/ArchivoJudicial'
      }
    }
  }
</script>
<style>
input[type=button],
  button {cursor: pointer;}
  input[type=button]:hover,
  button:hover {background-color: #007bff;}
  td a i {
    color:#343a40!important;
  }
   button {
    overflow: hidden
  }

  .prof-pic {
    font-size: 7vw;
    max-width: 400px;
  }
  td i {
    cursor:pointer;
  }
  .thumb {
  object-fit: cover;
  width:10vw;
  height:10vw;
}
#secciondebienvenidaARCHIVO {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  #secciondebienvenidaARCHIVO h2 {
    margin-top: 3vh;
    text-align: center;
  }

  #secciondebienvenidaARCHIVO h4 {
    margin-top:1vh;
  }

  @media (max-width: 991px) {
    #secciondebienvenidaARCHIVO h2 {
      font-size: .9rem;
    }
  }
  .h2-custom{
    margin-top: 3vh;
    text-align: center;
    color: var(--gris-pj);
  }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/comun/Plantilla.vue